import { Types } from '../../../actions/content/playlists'
import { ArrayUtils } from '../../../utils'
import initialState from '../initialState'
import { formatPlaylist } from './helpers'

export default (state, { type, payload = {}, meta = {} }) => {
    switch (type) {
        case Types.CREATE_PLAYLIST_CP_REQUEST:
        case Types.DESTROY_PLAYLIST_REQUEST:
        case Types.FETCH_PLAYLISTS_REQUEST:
        case Types.FETCH_PLAYLIST_SINGLE_REQUEST:
        case Types.UPDATE_PLAYLIST_REQUEST:
            return {
                ...state,
                isWorking: {
                    ...state.isWorking,
                    playlists: true,
                },
            }
        case Types.API_CALL_FAILURE:
            return {
                ...state,
                isWorking: {
                    ...state.isWorking,
                    playlists: false,
                },
            }
        case Types.DESELECT_PLAYLIST: {
            return {
                ...state,
                selected: {
                    ...state.selected,
                    playlists: initialState.selected.playlists,
                },
            }
        }
        case Types.FETCH_PLAYLISTS_SUCCESS:
            const playlists = payload.data.map(formatPlaylist)

            return {
                ...state,
                isWorking: {
                    ...state.isWorking,
                    playlists: false,
                },
                pagination: {
                    ...state.pagination,
                    playlists: {
                        currentPage: payload.current_page,
                        perPage: payload.per_page,
                        total: payload.total,
                        from: payload.from,
                        to: payload.to,
                    },
                },
                playlists: meta.noFirstPage ? [...state.playlists, ...playlists] : playlists,
            }
        case Types.FETCH_PLAYLIST_SINGLE_SUCCESS:
            return {
                ...state,
                isWorking: {
                    ...state.isWorking,
                    playlists: false,
                },
                selected: {
                    ...state.selected,
                    playlists: formatPlaylist(payload),
                },
            }
        case Types.EDIT_PLAYLIST_LAYER_ARRAY:
            return {
                ...state,
                selected: {
                    ...state.selected,
                    playlists: {
                        ...state.selected.playlists,
                        layers: payload,
                    },
                },
            }
        case Types.EDIT_PLAYLIST_MEDIA_ARRAY:
            return {
                ...state,
                selected: {
                    ...state.selected,
                    playlists: {
                        ...state.selected.playlists,
                        media: payload,
                    },
                },
            }
        case Types.UPDATE_PLAYLIST_SUCCESS:
            const formatedPlaylist = formatPlaylist(payload)
            if (meta.withArray)
                return {
                    ...state,
                    isWorking: {
                        ...state.isWorking,
                        playlists: false,
                    },
                    selected: {
                        ...state.selected,
                        playlists: { ...formatedPlaylist },
                    },
                }
            const indexUpdated = state.playlists.findIndex((playlist) => playlist.id === meta.id)
            const indexUpdatedSelected = state.selected.channels.playlists.findIndex((playlist) => playlist.id === meta.id)
            return {
                ...state,
                isWorking: {
                    ...state.isWorking,
                    playlists: false,
                },
                playlists: ArrayUtils.insertItem(state.playlists, indexUpdated, {
                    ...formatedPlaylist,
                }),
                selected: {
                    ...state.selected,
                    channels: {
                        ...state.selected.channels,
                        playlists: ArrayUtils.insertItem(state.selected.channels.playlists, indexUpdatedSelected, {
                            ...formatedPlaylist,
                        }),
                    },
                },
            }
        case Types.CREATE_PLAYLIST_CP_SUCCESS:
            return {
                ...state,
                isWorking: {
                    ...state.isWorking,
                    playlists: false,
                },
                contentPushContent: {
                    ...state.contentPushContent,
                    playlist: {
                        ...payload,
                    },
                },
            }
        case Types.DESTROY_PLAYLIST_FAILURE:
        case Types.DESTROY_PLAYLIST_SUCCESS:
            return {
                ...state,
                isWorking: {
                    ...state.isWorking,
                    playlists: false,
                },
                contentPushContent: {
                    ...state.contentPushContent,
                    playlist: null,
                },
            }
        case Types.CHANGE_PLAYLISTS:
            return {
                ...state,
                selected: {
                    ...state.selected,
                    channels: {
                        ...state.selected.channels,
                        playlists: payload,
                    },
                },
            }
        case Types.CHANGE_SELECTED_MEDIA:
            return {
                ...state,
                selected: {
                    ...state.selected,
                    playlists: {
                        ...state.selected.playlists,
                        media: payload,
                    },
                },
            }
        case Types.CHANGE_SELECTED_PLAYLIST: {
            return {
                ...state,
                selected: {
                    ...state.selected,
                    playlists: formatPlaylist(payload),
                },
            }
        }
        default:
            return null
    }
}
